import { ProviderBuilder, EGenMode } from '@educraft/base';
import { SpojovackaOrder } from './generators/SpojovackaOrder';
import {
  QR_Hra__Hunt as OrderQR_Hra__Hunt,
  QR_Hra__Path as OrderQR_Hra__Path,
  QR_Hra__Path_Poradi as OrderQR_Hra__Path_Poradi,
  QR_Hra__Seek as OrderQR_Hra__Seek,
  QR_Hra__Trail as OrderQR_Hra__Trail,
  QR_Hra__Check as OrderQR_Hra__Check,
  QR_Hra__Pairs as OrderQR_Hra__Pairs,
} from './generators/QR_Hra';
import {
  Piccolo__Base,
  Piccolo__23,
  Piccolo__2C,
  Piccolo__343,
  Piccolo__Okolo,
  Piccolo__P0,
  Piccolo__P1,
  Piccolo__Pyramid,
  Piccolo__RND,
  Piccolo__Diagonal,
  Primo__Base,
  Primo__2C,
  Primo__P0,
  Primo__P1,
  Primo__RND,
  Primo__Diagonal,
  Maximo__Base,
  Maximo__2C,
  Maximo__RND,
  Maximo__Diagonal,
} from './generators/Logico';
import {
  GeoBoard__8__Posloupnost,
  GeoBoard__920__Posloupnost,
} from './generators/GeoBoardPosloupnost';
import { ProvazekSeznam } from './generators/ProvazekSeznam';
import { SekvencniSkladacka } from './generators/SekvencniSkladacka';
import { SlovaNaRetezu__Zaklad, SlovaNaRetezu__Vypln } from './generators/WordChain';

export function registerLayoutList(builder: ProviderBuilder) {
  builder.add(EGenMode.LayoutList, SpojovackaOrder, 'List.SpojovackaOrder');
  builder.add(EGenMode.LayoutList, OrderQR_Hra__Hunt, 'List.QR_Hra__Hunt');
  builder.add(EGenMode.LayoutList, OrderQR_Hra__Path, 'List.QR_Hra__Path');
  builder.add(EGenMode.LayoutList, OrderQR_Hra__Path_Poradi, 'List.QR_Hra__Path_Poradi');
  builder.add(EGenMode.LayoutList, OrderQR_Hra__Seek, 'List.QR_Hra__Seek');
  builder.add(EGenMode.LayoutList, OrderQR_Hra__Trail, 'List.QR_Hra__Trail');
  builder.add(EGenMode.LayoutList, OrderQR_Hra__Check, 'List.QR_Hra__Check');
  builder.add(EGenMode.LayoutList, OrderQR_Hra__Pairs, 'List.QR_Hra__Pairs');
  // Piccolo (10 questions)
  builder.add(EGenMode.LayoutList, Piccolo__Base, 'List.Piccolo__Base');
  builder.add(EGenMode.LayoutList, Piccolo__23, 'List.Piccolo__23');
  builder.add(EGenMode.LayoutList, Piccolo__2C, 'List.Piccolo__2C');
  builder.add(EGenMode.LayoutList, Piccolo__343, 'List.Piccolo__343');
  builder.add(EGenMode.LayoutList, Piccolo__Okolo, 'List.Piccolo__Okolo');
  builder.add(EGenMode.LayoutList, Piccolo__P0, 'List.Piccolo__P0');
  builder.add(EGenMode.LayoutList, Piccolo__P1, 'List.Piccolo__P1');
  builder.add(EGenMode.LayoutList, Piccolo__Pyramid, 'List.Piccolo__Pyramid');
  builder.add(EGenMode.LayoutList, Piccolo__RND, 'List.Piccolo__RND');
  builder.add(EGenMode.LayoutList, Piccolo__Diagonal, 'List.Piccolo__Diagonal');
  // Primo (6 questions)
  builder.add(EGenMode.LayoutList, Primo__Base, 'List.Primo__Base');
  builder.add(EGenMode.LayoutList, Primo__2C, 'List.Primo__2C');
  builder.add(EGenMode.LayoutList, Primo__P0, 'List.Primo__P0');
  builder.add(EGenMode.LayoutList, Primo__P1, 'List.Primo__P1');
  builder.add(EGenMode.LayoutList, Primo__RND, 'List.Primo__RND');
  builder.add(EGenMode.LayoutList, Primo__Diagonal, 'List.Primo__Diagonal');
  // Maximo (18 questions)
  builder.add(EGenMode.LayoutList, Maximo__Base, 'List.Maximo__Base');
  builder.add(EGenMode.LayoutList, Maximo__2C, 'List.Maximo__2C');
  builder.add(EGenMode.LayoutList, Maximo__RND, 'List.Maximo__RND');
  builder.add(EGenMode.LayoutList, Maximo__Diagonal, 'List.Maximo__Diagonal');
  // GeoBoard sequence
  builder.add(EGenMode.LayoutList, GeoBoard__8__Posloupnost, 'List.GeoBoard__8__Posloupnost');
  builder.add(EGenMode.LayoutList, GeoBoard__920__Posloupnost, 'List.GeoBoard__920__Posloupnost');
  // Additional generators
  builder.add(EGenMode.LayoutList, ProvazekSeznam, 'List.ProvazekSeznam');
  builder.add(EGenMode.LayoutList, SekvencniSkladacka, 'List.SekvencniSkladacka');
  builder.add(EGenMode.LayoutList, SlovaNaRetezu__Zaklad, 'List.SlovaNaRetezu__Zaklad');
  builder.add(EGenMode.LayoutList, SlovaNaRetezu__Vypln, 'List.SlovaNaRetezu__Vypln');
}
